// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const statue = defineModel({
  id: "statue",
  batchId: "future",
  name: "Statue",
  tags: ["scenery","statue","low-poly","age-of-mcp","future"],
  summary: "A carved statue — civic ornament and prestige.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.32,
  variants: [
    { id: "variant-0", label: "Variant 1", parts: () => [
      { geometry: new THREE.BoxGeometry(0.4, 0.08, 0.4), color: "#6c655b", position: [0, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.32, 0.08, 0.32), color: "#8a847a", position: [0, 0.12, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.26, 0.22), color: "#8a847a", position: [0, 0.29, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.03, 0.24), color: "#6c655b", position: [0, 0.43, 0] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.09, 0.26, 7), color: "#7d7a5f", position: [0, 0.58, 0] },
      { geometry: new THREE.SphereGeometry(0.05, 7, 6), color: "#8f8c6e", position: [0, 0.77, 0] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.16, 5), color: "#7d7a5f", position: [0.06, 0.71, 0.02], rotation: [0, 0, -1.1] },
      { geometry: new THREE.CylinderGeometry(0.02, 0.02, 0.13, 5), color: "#7d7a5f", position: [-0.06, 0.61, 0], rotation: [0, 0, 0.3] },
    ] },
    { id: "variant-1", label: "Variant 2", parts: () => [
      { geometry: new THREE.BoxGeometry(0.4, 0.08, 0.4), color: "#6c655b", position: [0, 0.04, 0] },
      { geometry: new THREE.BoxGeometry(0.32, 0.08, 0.32), color: "#8a847a", position: [0, 0.12, 0] },
      { geometry: new THREE.BoxGeometry(0.22, 0.26, 0.22), color: "#8a847a", position: [0, 0.29, 0] },
      { geometry: new THREE.BoxGeometry(0.24, 0.03, 0.24), color: "#6c655b", position: [0, 0.43, 0] },
      { geometry: new THREE.IcosahedronGeometry(0.08, 0), color: "#7d7a5f", position: [0, 0.57, 0], scale: [1.8, 1, 0.9] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.14, 5), color: "#7d7a5f", position: [0.1, 0.49, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.14, 5), color: "#7d7a5f", position: [-0.1, 0.49, 0.05] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.14, 5), color: "#7d7a5f", position: [0.1, 0.49, -0.05] },
      { geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.14, 5), color: "#7d7a5f", position: [-0.1, 0.49, -0.05] },
      { geometry: new THREE.BoxGeometry(0.06, 0.04, 0.04), color: "#8f8c6e", position: [0.18, 0.63, 0], rotation: [0, 0, -0.3] },
      { geometry: new THREE.CylinderGeometry(0.03, 0.045, 0.14, 6), color: "#8f8c6e", position: [-0.02, 0.69, 0] },
      { geometry: new THREE.SphereGeometry(0.04, 6, 5), color: "#7d7a5f", position: [-0.02, 0.79, 0] },
    ] },
  ],
  animations: [],
});
